import { create } from 'zustand';
import { SmartHelpProps } from '../Smarts/SmartHelp';

export type ProductType = 'audience' | 'programmatic' | 'full' | 'admin';

export type TopBarState = {
	title?: string;
	children?: React.ReactNode | null;
	productType?: ProductType;
	smartHelp?: SmartHelpProps;
	smartHelpOpen?: boolean;
};

type TopBarStore = TopBarState & {
	setState: (state: Partial<TopBarState>) => void;
	setTitle: (title: string) => void;
	setChildren: (children: React.ReactNode | null) => void;
	setProductType: (productType: ProductType) => void;
	setSmartHelp: (smartHelp: SmartHelpProps) => void;
	setSmartHelpOpen: (smartHelpOpen: boolean) => void;
	reset: () => void;
};

export const useTopBarStore = create<TopBarStore>((set) => ({
	// Initial state
	title: undefined,
	children: null,
	productType: undefined,
	smartHelp: undefined,
	smartHelpOpen: false,

	// Actions
	setState: (newState) => set((state) => ({ ...state, ...newState })),
	setTitle: (title) => set({ title }),
	setChildren: (children) => set({ children }),
	setProductType: (productType) => set({ productType }),
	setSmartHelp: (smartHelp) => set({ smartHelp }),
	setSmartHelpOpen: (smartHelpOpen) => set({ smartHelpOpen }),
	reset: () => set({
		title: undefined,
		children: null,
		productType: undefined,
		smartHelp: undefined,
		smartHelpOpen: false,
	}),
}));
